module.exports = __webpack_public_path__ + "img/binity.d9990bb1.svg";